"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.undefFilter = void 0;
const undefFilter = (arr) => {
    return arr.filter(i => i !== undefined);
};
exports.undefFilter = undefFilter;
